<script src="../router/index.js"></script>
<template>
    <!-- page-wrapper Start-->
    <div class="page-wrapper">
        <div class="container-fluid p-0">
            <!-- login page start-->
            <div class="authentication-main">
                <div class="row">
                    <div class="col-md-12">
                        <div class="auth-innerright">
                            <div class="authentication-box">
                                <div class="card mt-4">
                                    <div class="card-body">
                                        <div class="text-center">
                                            <img alt="" src="../assets/images/logo_gms.png" style="width: 405px">
                                        </div>
                                        <form class="theme-form">
                                            <div class="form-group">
                                                <label class="col-form-label pt-0">R.U.T</label>
                                                <masked-input class="form-control" id="username_id"
                                                              v-model="username"
                                                              placeholder="12.345.678-9"
                                                              :mask="maskRUT"
                                                />
                                            </div>
                                            <div class="form-group">
                                                <label class="col-form-label">Contraseña</label>
                                                <input v-model="password" class="form-control" required="" type="password" style="border: 1px solid #ced4da;" placeholder="***********">
                                            </div>
                                            <b-form-invalid-feedback :state="isValid" class="text-center">Usuario o contraseña incorrecta.</b-form-invalid-feedback>
                                            <div class="offset-5" v-show="isSend">
                                                <div class="loader">
                                                    <div class="line bg-primary"></div>
                                                    <div class="line bg-primary"></div>
                                                    <div class="line bg-primary"></div>
                                                    <div class="line bg-primary"></div>
                                                </div>
                                            </div>
                                            <div class="form-group form-row mt-3 mb-0">
                                                <button @click="signUp" class="btn btn-primary btn-block" type="submit">Iniciar Sesión</button>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- login page end-->
        </div>
    </div>
    <!-- latest jquery-->
</template>

<script>
    import axios from "axios";
    import MaskedInput from "vue-masked-input";

    export default {
        name: 'login',
        components: {
            MaskedInput,
        },
        data() {
            return {
                isSend: false,
                username: '',
                password: '',
                isValid: true,
                maskRUT: {
                    pattern: '##.###.###-V',
                    formatCharacters: {
                        'V': {
                            validate: char => /[1-9kK]/.test(char),
                            transform: char => char.toUpperCase(),
                        },
                    },
                }
            }
        },
        methods: {
            async signUp (evt) {
                evt.preventDefault();
                this.isValid = true;
                this.isSend = true;
                const path = '/api/login/';
                const data = {
                    username: this.username,
                    password: this.password
                };
                await axios.post(path, data).then((response) => {
                    localStorage.setItem('token', response['data']['token']);
                    localStorage.setItem('worker', JSON.stringify(response['data']['worker']));
                    // console.log(response['data']['token'])
                    this.$router.push({'name': 'RouteMap'});
                }).catch(() => {
                    this.isValid = false;
                });
                this.isSend = false;
            },

        }
    }
</script>